module.exports = __webpack_public_path__ + "static/media/sub_background_desktop.e7099f0b.png";